import { useI18n } from '~/app/i18n/i18n';

export const PaintFallbackSvg = () => {
	const { i18n } = useI18n();
	return (
		<svg
			role="img"
			aria-label={i18n('ngc.a11y.placeholderImage')}
			width="68"
			height="68"
			viewBox="0 0 68 68"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect width="68" height="68" rx="34" fill="black" fillOpacity="0.05" />
			<mask
				id="mask0_1795_19043"
				style={{ maskType: 'alpha' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="68"
				height="68">
				<rect width="68" height="68" rx="34" fill="#F2F2F2" />
			</mask>
			<g mask="url(#mask0_1795_19043)">
				<path d="M-4 26L73.5 19" stroke="#B3B3B3" />
				<path d="M-4 28L73.5 21" stroke="#B3B3B3" />
			</g>
		</svg>
	);
};
